import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BagButton } from "./BagButton";

export const Nav = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/5"
    data-testid="main-nav"
  >
    <div className="max-w-[1600px] mx-auto flex items-center justify-between px-6 md:px-12 py-4">
      <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo-link">
        <span className="block h-9 w-9 overflow-hidden rounded-full border border-gold/40">
          <img
            src="/assets/logo.jpg"
            alt="RayStance monogram"
            className="h-full w-full object-cover object-top scale-[1.6] origin-top"
          />
        </span>
        <span className="font-serif text-lg tracking-[0.25em] text-white group-hover:text-gold transition-colors duration-500">
          RAYSTANCE
        </span>
      </Link>
      <nav className="flex items-center gap-8 text-xs uppercase tracking-[0.2em] text-ash">
        <Link to="/collection" className="hover:text-gold transition-colors duration-500" data-testid="nav-collection-link">
          Collection
        </Link>
        <Link to="/lookbook" className="hover:text-gold transition-colors duration-500" data-testid="nav-lookbook-link">
          Lookbook
        </Link>
        <Link to="/#story" className="hover:text-gold transition-colors duration-500" data-testid="nav-story-link">
          The Story
        </Link>
        <BagButton />
      </nav>
    </div>
  </motion.header>
);
